<template>
    <span>

        <a @click="shengchengmission()">{{ buttinname }}</a>
        <a-modal :visible="missionvisible" :width="1280" title="班级列表" @ok="postsquadmission" @cancel="handleCancelmission">
            <a-row :gutter="[16, 16]" type="flex" justify="space-between">
                <a-col :span="5">
                </a-col>
                <a-col>
                    <a-form layout="inline">
                        <a-form-item>
                            <a-select v-model="searchFrom.subject" placeholder="学科" style="width: 120px;" allow-clear>
                                <a-select-option :value="1">数学</a-select-option>
                                <a-select-option :value="2">英语</a-select-option>
                                <a-select-option :value="3">语文</a-select-option>
                                <a-select-option :value="4">化学</a-select-option>
                                <a-select-option :value="5">物理</a-select-option>
                            </a-select>
                        </a-form-item>


                        <a-form-item>
                            <a-select v-model="searchFrom.type" placeholder="班型" style="width: 120px;" allow-clear>
                                <a-select-option :key="0" :value="0">培优班</a-select-option>
                                <a-select-option :key="1" :value="1">提高班</a-select-option>
                                <a-select-option :key="2" :value="2">英才班</a-select-option>
                                <a-select-option :key="3" :value="3">1对1VIP班</a-select-option>
								 <a-select-option :key="4" :value="4">体验课</a-select-option>
								  <a-select-option :key="5" :value="5">冲刺班</a-select-option>
                            </a-select>
                        </a-form-item>


                        <a-form-item>
                            <a-select v-model="searchFrom.campus_id" placeholder="校区" style="width: 150px;" allow-clear>
                                <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{ item.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <!--  <a-form-item>
                            <a-select v-model="searchFrom.course_id" placeholder="课程" style="width: 220px;" allow-clear>
                                <a-select-option v-for="(item) in courseList" :key="item.id" :value="item.id">{{item.name}}
                                </a-select-option>
                            </a-select>
                        </a-form-item> -->

                        <a-form-item>
                            <a-select v-model="searchFrom.interval" placeholder="间隔时间" allow-clear style="width: 120px;">
                                <a-select-option :key="0" :value="0">全部</a-select-option>
                                <a-select-option :key="4" :value="4">每周五</a-select-option>
                                <a-select-option :key="1" :value="1">每周六</a-select-option>
                                <a-select-option :key="2" :value="2">每周天</a-select-option>
                                <a-select-option :key="3" :value="3">每天</a-select-option>
                            </a-select>
                        </a-form-item>

                        <a-form-item>
                            <a-select v-model="searchFrom.opening" placeholder="开班状态" allow-clear style="width: 120px;">
                                <a-select-option :key="0" :value="0">未开班</a-select-option>
                                <a-select-option :key="1" :value="1">已开班</a-select-option>
                                <a-select-option :key="2" :value="2">已结班</a-select-option>
                            </a-select>
                        </a-form-item>

                        <a-form-item>
                            <a-select v-model="searchFrom.year_name" placeholder="年度" allow-clear style="width: 120px;">
                                <a-select-option :key="0" value="2020">2020年</a-select-option>
                                <a-select-option :key="1" value="2021">2021年</a-select-option>
                                <a-select-option :key="2" value="2022">2022年</a-select-option>
                                <a-select-option :key="3" value="2023">2023年</a-select-option>
								<a-select-option :key="4" value="2024">2024年</a-select-option>
                            </a-select>
                        </a-form-item>

                        <a-form-item>
                            <a-select v-model="searchFrom.grade_id" placeholder="年级" style="width: 220px;" allow-clear>
                                <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select v-model="searchFrom.semester_name" placeholder="季度" allow-clear style="width: 120px;">
                                <a-select-option :key="0" value="寒假">寒假</a-select-option>
                                <a-select-option :key="1" value="春季">春季</a-select-option>
                                <a-select-option :key="2" value="暑假">暑假</a-select-option>
                                <a-select-option :key="3" value="秋季">秋季</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select v-model="searchFrom.status" placeholder="班级状态" allow-clear style="width: 120px;">
                                <a-select-option :key="0" :value="0">禁用</a-select-option>
                                <a-select-option :key="1" :value="1">可用</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-select v-model="searchFrom.is_famission" placeholder="是否发送任务" allow-clear
                                style="width: 120px;">
                                <a-select-option :key="1" :value="1">发送</a-select-option>
                                <a-select-option :key="0" :value="0">不发送</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-input placeholder="班级名称" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
                        </a-form-item>
                        <a-form-item>
                            <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                        </a-form-item>
                    </a-form>
                </a-col>
            </a-row>
            <a-divider></a-divider>
            <div>

                <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                    @change="onPaginationChange" :row-selection="rowSelection" bordered>
                    <a-table-column key="gradename" title="年级" data-index="gradename" />
                    <a-table-column key="name" title="班级" data-index="name" />
                    <a-table-column key="interval" title="时间">
                        <template slot-scope="item">
                            <span v-if="item.interval == 1">每周六</span>
                            <span v-if="item.interval == 2">每周天</span>
                            <span v-if="item.interval == 3">每天</span>
                            <span v-if="item.phase == 1">第一阶段</span>
                            <span v-if="item.phase == 2">第二阶段</span>
                            <span v-if="item.phase == 3">第三阶段</span>
                            <span v-if="item.phase == 4">第四阶段</span>
							<span v-if="item.phase == 5">第五阶段</span>
                        </template>
                    </a-table-column>
                    <a-table-column key="campusname" title="校区" data-index="campusname" />
                    <a-table-column key="coursename" title="课程包" data-index="coursename" />
                    <!--  <a-table-column key="amount" title="计划人数" data-index="amount" /> -->
                    <!--   <a-table-column key="code" title="班级码" data-index="code" /> -->
                    <a-table-column key="banzhuren" title="班主任" data-index="banzhuren" />
                    <a-table-column key="teacher" title="任课老师" data-index="teacher" />
                    <a-table-column key="type" title="班型">
                        <template slot-scope="item">
                            <span v-if="item.type == 0">培优班</span>
                            <span v-if="item.type == 1">提高班</span>
                            <span v-if="item.type == 2">英才班</span>
                            <span v-if="item.type == 3">1对1VIP班</span>
                            <span v-if="item.type == 4">体验课</span>
							 <span v-if="item.type == 5">冲刺班</span>

                        </template>
                    </a-table-column>
                    <a-table-column key="opening" title="开班状态">
                        <template slot-scope="item">
                            <span v-if="item.opening == 0">未开班</span>
                            <span v-if="item.opening == 1">已开班</span>
                            <span v-if="item.opening == 2">已结班</span>
                        </template>
                    </a-table-column>
                    <!-- <a-table-column key="status" width="100px;" title="状态">
                        <template slot-scope="item">
                            <span v-if="item.status==1">可用</span>
                            <span v-if="item.status==0">已禁用</span>
                        </template>
                    </a-table-column> -->

                </a-table>
            </div>
            <div>总共选择{{ squad_id.length }}个班级</div>
        </a-modal>
    </span>
</template>
<script>
import AFormItem from "ant-design-vue/es/form/FormItem";
export default {
    components: {
        AFormItem
    },
    props: {
        itemdata: {
        },
        buttinname: undefined,
    },
    data() {
        return {
            data: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
            loading: false,
            bindVisible: false,
            missionvisible: false,
            courseList: [],
            courseTeacherList: [],
            searchFrom: {
                keyword: undefined,
                course_id: undefined,
                campus_id: undefined,
                interval: undefined,
                opening: 1,
                status: 1,
                is_famission: 1,
                subject: undefined
            },
            courseChapterList: [],
            campusList: [],
            gradeList: [],
            squad_id: [],
        };
    },
    mounted() {

    },
    computed: {
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    selectedRows;
                    this.squad_id = selectedRowKeys;
                    // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                },

            };
        },
    },
    methods: {
        changeFormCampus(campus_id) {
            this.getCourseTeacherList({
                campus_id: campus_id
            });
        },
        getGradeList() {
            this.$axios
                .post("/api/BasicGrade/index")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });

                    } else {
                        this.gradeList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCourseTeacherList() {
            this.$axios
                .post("/api/OrgCampus/getteacher", {
                    pageinfo: {
                        pageSize: 9999
                    }
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.courseTeacherList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },

        getCourseList() {
            this.$axios
                .post("/api/BasicCourse/index", {
                    pageinfo: {
                        pageSize: 9999
                    }
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.courseList = res.data.data;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getCampusList() {
            this.$axios
                .post("/api/Admin/getmycampuslist")
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.campusList = res.data;
                        this.tableSearch();
                        this.getCourseList();
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        selectItem(pid) {
            this.form.pid = pid;
        },

        changeStatus(data) {
            this.$axios
                .post("/api/OrgSquad/edit", {
                    data
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.tableSearch();
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        changeCampus(e) {
            this.searchForm.campus_id = e;
        },
        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList(this.searchFrom);
        },
        tableSearch() {
            this.pageinfo.current = 1;
            this.getTableList(this.searchFrom);
        },
        getTableList(data) {
            this.loading = true;
            this.$axios
                .post("/api/OrgSquad/index", {
                    data,
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });

                    } else {
                        this.data = res.data.data;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },
        shengchengmission() {
            this.missionvisible = true;
            this.getCampusList();
            this.getGradeList();
        },
        postsquadmission() {
            if (this.squad_id.length != 0) {
                var data = {};
                data.itemdata = this.itemdata;
                data.squad_id = this.squad_id;
                this.$emit('getsquad', data);
                this.missionvisible = false;
            } else {
                this.missionvisible = false;
            }
        },
        handleCancelmission() {
            this.missionvisible = false;
        },

        modalCancel() {
            this.visible = false;
            this.bindVisible = false;
        },
        modalCourseChapterCancel() {
            this.courseChapterVisible = false;
        }
    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
